// Pikaday set
import Pickaday from 'pikaday'
import 'pikaday/css/pikaday.css'
import moment from 'moment-timezone'
import i18n from './i18nHelpers'

function convertDate (value) {
  const arr = value.split('/')
  return arr[2] + '-' + arr[1] + '-' + arr[0]
}

const calendarLang = {
  previousMonth: i18n.t('message.calendar.last_month'),
  nextMonth: i18n.t('message.calendar.next_month'),
  months: [i18n.t('message.calendar.month.01'), i18n.t('message.calendar.month.02'), i18n.t('message.calendar.month.03'), i18n.t('message.calendar.month.04'), i18n.t('message.calendar.month.05'), i18n.t('message.calendar.month.06'), i18n.t('message.calendar.month.07'), i18n.t('message.calendar.month.08'), i18n.t('message.calendar.month.09'), i18n.t('message.calendar.month.10'), i18n.t('message.calendar.month.11'), i18n.t('message.calendar.month.12')],
  weekdays: [i18n.t('message.calendar.week.01'), i18n.t('message.calendar.week.02'), i18n.t('message.calendar.week.03'), i18n.t('message.calendar.week.04'), i18n.t('message.calendar.week.05'), i18n.t('message.calendar.week.06'), i18n.t('message.calendar.week.07')],
  weekdaysShort: [i18n.t('message.calendar.week_short.01'), i18n.t('message.calendar.week_short.02'), i18n.t('message.calendar.week_short.03'), i18n.t('message.calendar.week_short.04'), i18n.t('message.calendar.week_short.05'), i18n.t('message.calendar.week_short.06'), i18n.t('message.calendar.week_short.07')]
}

let events = []
let disallowedDates = []
let fullyBookedDates = []

const VuePikaday = {
  bind (el, ref) {
    moment.tz.setDefault('Asia/Bangkok')
    // Check professional available related calendar
    if (ref.arg === 'professionalCalendar') {
      events = ref.value.events
      disallowedDates = ref.value.disallowedDates
      fullyBookedDates = ref.value.fullyBookedDates
    }
    const currentHour = moment().hour() // => 9
    let numDay = 1
    if (currentHour >= 20) {
      numDay = 2
    }

    if (ref.arg === 'transferDate' || ref.value === moment().format('DD/MM/YYYY')) {
      numDay = 0
    }

    const today = moment().add(numDay, 'days')
    const picker = new Pickaday({
      field: el,
      i18n: calendarLang,
      minDate: today.toDate(),
      format: 'DD/MM/YYYY',
      events,
      disableDayFn (date) {
        // const calendarDate = date.getYear() + '-' + date.getMonth() + '-' + date.getDate()
        try {
          const calendarDate = moment(date).format('YYYY-MM-DD')
          return ((disallowedDates && disallowedDates.indexOf(calendarDate) !== -1) || (fullyBookedDates && fullyBookedDates.indexOf(calendarDate) !== -1))
        } catch (e) {
          console.log('check calendar error', e)
        }
      },
      onSelect () {
        const newDate = new Date(picker._d)
        let d = newDate.getDate()
        let m = newDate.getMonth() + 1

        if (d < 10) {
          d = '0' + d
        }

        if (m < 10) {
          m = '0' + m
        }

        const pickDate = d + '/' + m + '/' + newDate.getFullYear()
        el.value = pickDate
        ref.value = pickDate
      }
    })

    if (ref.value) {
      picker.setDate(convertDate(ref.value.toString()))
    }
  },
  update (el, ref) {
    if (ref.arg === 'professionalCalendar') {
      events = ref.value.events
      disallowedDates = ref.value.disallowedDates
      fullyBookedDates = ref.value.fullyBookedDates
    }
  }
}

export default VuePikaday



// WEBPACK FOOTER //
// ./src/helpers/pickadayHelpers.js